<template>
  <div class="box">
    <div class="g-certi-box" v-if="type === 1" @click="onGetCerti('')">
      <slot></slot>
    </div>
    <span @click="onGetCerti('')" slot="reference" v-else><slot></slot></span>
    <selectSubjectDialog
      v-if="sSDialogVisible"
      :dialogVisible="sSDialogVisible"
      :param="sSDialogData"
      @setSSDialogData="onSetSSDialogData"
    ></selectSubjectDialog>
  </div>
</template>

<script>
import { ApiMethods, configUrl } from "@/assets/js/http-serve/http-methods";
import { ApiCorpMethods } from "@/assets/js/http-serve/corp/http-methods";
import SelectSubjectDialog from "./selectSubjectDialog";
import { isInDingTalk } from "../../assets/js/utils/ding-env";

export default {
  components: { SelectSubjectDialog },
  props: {
    isConsole: {
      type: Boolean,
      default: false
    },
    newUrl: {
      type: Number,
      default: 1
    },
    param: {
      type: Object
    },
    type: {
      type: Number,
      default: 0
    },
    listType: {
      type: String,
      default: "seniorList"
    },
    requestType: {
      type: String,
      default: ""
    }
  },
  data () {
    return {
      sSDialogVisible: false, // 请选择出证主体身份弹出框显示
      sSDialogData: {} //请选择出证主体身份数据
    };
  },
  computed: {
    currentIsCorpUser () {
      // 当前是否是集团账户

      // let _currentAuthUser = this.$store.getters.currentAuthUser;
      // if(_currentAuthUser && _currentAuthUser.corpId){
      //   return true;
      // }
      if (
        (this.$store.getters.currentAuthUser || {}).hasOwnProperty("superFlag")
      ) {
        return true;
      }

      return false;
    }
  },
  methods: {
    onSetSSDialogData (data) {
      this.sSDialogVisible = data.sSDialogVisible;
      this.sSDialogData = {};
      if (data.sSDialogData) {
        let _data = {
          ...data.sSDialogData.certData,
          code: data.sSDialogData.certiType
        };
        this.gotoRedirectTesity(_data);
      }
    },
    async onGetCerti (code) {
      let _this = this;
      let _param = _this.param;
      if (!_param.ts || !_param.sign) {
        let viewUrlParam = { signNo: _param.signNo, applyNo: _param.applyNo };
        let viewUrlRes;

        // 接口调用重构 start
        // author：yf
        // time：20210204
        if (
          this.$route.path.indexOf("console") > -1 ||
          this.requestType === "memberContract"
        ) {
          //corpViewUrl  ----
          // 控制台里面调用/c/m
          viewUrlRes = await ApiCorpMethods.ContractController.viewUrl(
            viewUrlParam
          );
        } else {
          // 工作台里面分（个人企业调用/i）和（集团调用/c）
          if (!this.currentIsCorpUser && !this.isConsole) {
            // 个人或者企业
            viewUrlRes = await ApiMethods.UserApplySignController.viewUrl(
              viewUrlParam
            );
          } else {
            // 集团
            // viewUrlRes = await ApiCorpMethods.ContractController.viewUrl(
            viewUrlRes = await ApiCorpMethods.ContractController.corpViewUrl(
              viewUrlParam
            );
          }
        }
        // 接口调用重构 end

        if (!viewUrlRes.success) {
          return _this.$message.error(
            viewUrlRes.description || "初始化数据失败"
          );
        }
        _param = viewUrlRes.data;
      }
      let certiRes = await ApiMethods.ApplySignController.certi(_param);
      if (certiRes.success) {
        if (certiRes.data.length === 1) {
          let _data = { ...certiRes.data[0] };
          return _this.gotoRedirectTesity(_data);
        }
        if (certiRes.data.length > 1) {
          this.sSDialogData.certData = certiRes.data;
          this.sSDialogVisible = true;
        }
      } else {
        let certiListRes = await ApiMethods.ApplySignController.certiList(
          _param
        );
        if (certiListRes.success) {
          if (!certiListRes.data || certiListRes.data.length == 0)
            return _this.$message.error("初始化数据失败");
          if (certiListRes.data.length === 1) {
            let _data = { ...certiListRes.data[0] };
            return _this.gotoRedirectTesity(_data);
          }
          if (certiListRes.data.length > 1) {
            this.sSDialogData.certData = certiListRes.data;
            this.sSDialogVisible = true;
          }
        } else {
          _this.$message.error(certiListRes.description);
        }
      }
    },
    async gotoRedirectTesity (data) {
      console.log("gotoRedirectTesity参数打印", data);
      // newUrl 0 旧业面 1 新页面
      let _this = this,
        ow = null;
      data.newUrl = _this.newUrl;
      if (!isInDingTalk) ow = window.open("about:blank");
      let redirectTesityRes = await ApiMethods.CertiController.redirectTesity(
        data
      );
      if (redirectTesityRes.success) {
        if (isInDingTalk) location.href = redirectTesityRes.data;
        if (!isInDingTalk) ow.location.href = redirectTesityRes.data;
      } else {
        _this.$message.error(redirectTesityRes.description || this.$tip);
        if (!isInDingTalk) ow.close();
      }
    },
    openSSDialog (data, certiType) {
      this.sSDialogVisible = true;
      this.sSDialogData = {
        certData: data,
        certiType: certiType
      };
    }
  }
};
</script>

<style lang="less">
.box {
  display: inline-block;
}
.g-certi-box {
  position: relative;
  &:hover {
    .content-warp {
      display: block;
    }
  }
  .content-warp {
    width: 100%;
    display: none;
    position: absolute;
    top: 100%;
    left: 0;
    padding-top: 5px;
  }
  .content {
    width: 100%;
    background-color: #fff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    position: relative;
    &::before {
      content: "";
      display: block;
      position: absolute;
      border: 6px solid #fff;
      z-index: 1;
      top: -6px;
      left: 50%;
      transform: rotate(45deg);
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }
  }
}

.g-certi-popover {
  border: none !important;
  border-radius: 3px;
  min-width: 125px !important;
}
.g-certi-list {
  width: 100%;
  .item {
    font-size: 14px;
    position: relative;
    border-radius: 4px;
    box-sizing: border-box;
    z-index: 2;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: rgba(41, 2, 2, 0.65);
    line-height: 35px;
    padding-left: 10px;
    background-color: #fff;
    cursor: pointer;
    &:hover {
      color: rgba(236, 28, 28, 1);
      background-color: #f9f6f6;
    }
  }
}
</style>



// WEBPACK FOOTER //
// components/apply-list/certiServicepopover.vue